/* ===== ALETARGA · interacción y animaciones ===== */
(() => {
  const MX = window.MX || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: MX.currency || 'EUR' });
  const money = (cents) => fmt.format(cents / 100);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Cabecera ---------- */
  const header = $('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 10);
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Títulos palabra a palabra ---------- */
  $$('[data-split]').forEach((el) => {
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map((w, i) => `<span class="w"><span style="--i:${i}">${w}</span></span>`).join(' ');
  });

  /* ---------- Contadores ---------- */
  const countUp = (el) => {
    const end = parseInt(el.dataset.count, 10) || 0;
    if (reduced) { el.textContent = end; return; }
    const t0 = performance.now(), dur = 1400;
    const tick = (t) => {
      const k = Math.min(1, (t - t0) / dur);
      el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* ---------- Aparición al hacer scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      $$('[data-count]', e.target).forEach(countUp);
      if (e.target.matches('[data-count]')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  $$('[data-reveal], [data-split], .mx-size__item').forEach((el) => io.observe(el));

  /* ---------- Scroll suave al comprador ---------- */
  $$('[data-scroll-buy], [data-sticky-btn]').forEach((b) => b.addEventListener('click', (e) => {
    const target = $('#comprar');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
  }));

  /* ---------- Galería ---------- */
  const gal = $('[data-gallery]');
  if (gal) {
    const slides = $$('[data-slide]', gal), thumbs = $$('[data-thumb]', gal);
    let cur = 0;
    const go = (i) => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === cur));
      thumbs[cur] && thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    $('[data-prev]', gal)?.addEventListener('click', () => go(cur - 1));
    $('[data-next]', gal)?.addEventListener('click', () => go(cur + 1));
    if (slides.length < 2) $$('.mx-gallery__nav', gal).forEach((b) => (b.hidden = true));
    let x0 = null;
    const main = $('.mx-gallery__main', gal);
    main.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    main.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------- Fecha de entrega estimada ---------- */
  const eta = $('[data-eta]');
  if (eta) {
    const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    const f = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
    const now = new Date();
    eta.textContent = `${f.format(addBiz(now, +eta.dataset.min || 5))} y el ${f.format(addBiz(now, +eta.dataset.max || 10))}`;
  }

  /* ---------- Formulario de producto con packs ---------- */
  const form = $('[data-product-form]');
  if (form) {
    const data = JSON.parse($('[data-product-json]', form).textContent);
    const variants = data.variants;
    const tiers = data.tiers;
    const unitsBox = $('[data-units]', form);
    // por defecto la talla XL (la más habitual en adultos), si no la primera disponible
    const firstAvail = variants.find((v) => v.available && /^XL[^A-Z]/i.test(v.title)) || variants.find((v) => v.available) || variants[0];
    let qty = 1;
    let picks = [firstAvail.id, firstAvail.id, firstAvail.id];

    const label = (title) => {
      const m = title.match(/^([A-Za-z]+)\s*[-–/ ]\s*(\d+)\s*cm/i);
      return m ? { main: m[1].toUpperCase(), sub: `${m[2]} cm` } : { main: title, sub: '' };
    };
    const byId = (id) => variants.find((v) => v.id === id);

    const renderUnits = () => {
      unitsBox.innerHTML = '';
      for (let u = 0; u < qty; u++) {
        const row = document.createElement('div');
        row.className = 'mx-unit';
        row.style.animationDelay = `${u * 70}ms`;
        row.innerHTML = (qty > 1 ? `<span class="mx-unit__n">Ud. ${u + 1}</span>` : '') + '<div class="mx-chips" role="radiogroup"></div>';
        const chips = $('.mx-chips', row);
        chips.setAttribute('aria-label', `Talla unidad ${u + 1}`);
        variants.forEach((v) => {
          const l = label(v.title);
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mx-chip' + (picks[u] === v.id ? ' is-active' : '');
          b.disabled = !v.available;
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', picks[u] === v.id);
          b.innerHTML = `${l.main}${l.sub ? `<small>${l.sub}</small>` : ''}`;
          b.addEventListener('click', () => { picks[u] = v.id; renderUnits(); renderPrices(); });
          chips.appendChild(b);
        });
        unitsBox.appendChild(row);
      }
    };

    const tierTotal = (q) => {
      let full = 0, was = 0;
      for (let u = 0; u < q; u++) {
        const v = byId(picks[u]) || firstAvail;
        full += v.price;
        was += Math.max(v.compare || 0, v.price);
      }
      const disc = tiers[q - 1] || 0;
      return { now: Math.round(full * (1 - disc / 100)), was };
    };

    const renderPrices = () => {
      [1, 2, 3].forEach((q) => {
        const t = tierTotal(q);
        const nowEl = $(`[data-tier-price="${q}"]`, form), wasEl = $(`[data-tier-was="${q}"]`, form);
        if (nowEl) nowEl.textContent = money(t.now);
        if (wasEl) wasEl.textContent = t.was > t.now ? money(t.was) : '';
      });
      const cur = tierTotal(qty);
      $('[data-atc-price]', form).textContent = money(cur.now);
      const sp = $('[data-sticky-price]');
      if (sp) sp.textContent = money(tierTotal(1).now);
    };

    $$('[data-bundle]', form).forEach((lab) => {
      const input = $('input', lab);
      input.addEventListener('change', () => {
        qty = +input.value;
        $$('[data-bundle]', form).forEach((l) => l.classList.toggle('is-active', l === lab));
        renderUnits(); renderPrices();
      });
    });

    const err = $('[data-form-error]', form);
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('[data-atc]', form);
      err.hidden = true;
      const counts = {};
      picks.slice(0, qty).forEach((id) => (counts[id] = (counts[id] || 0) + 1));
      const items = Object.entries(counts).map(([id, quantity]) => ({ id: +id, quantity, properties: qty > 1 ? { _pack: `Pack ${qty}` } : {} }));
      btn.classList.add('is-loading');
      try {
        await Cart.add(items);
        btn.classList.remove('is-loading'); btn.classList.add('is-done');
        const lab = $('[data-atc-label]', btn), old = lab.innerHTML;
        lab.innerHTML = '¡A la cesta! ✓';
        flyToCart($('.mx-gallery__slide.is-active img'));
        setTimeout(() => { btn.classList.remove('is-done'); lab.innerHTML = old; renderPrices(); }, 1800);
        Cart.open();
      } catch (ex) {
        btn.classList.remove('is-loading');
        err.textContent = ex.message || 'No se ha podido añadir. Inténtalo de nuevo.';
        err.hidden = false;
      }
    });

    renderUnits(); renderPrices();

    /* barra fija: aparece cuando el botón principal sale de pantalla */
    const sticky = $('[data-sticky]');
    if (sticky) {
      const atc = $('[data-atc]', form);
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', !show);
        $('[data-sticky-btn]', sticky).tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
  }

  /* ---------- Animación "vuela a la cesta" ---------- */
  function flyToCart(img) {
    const target = $('[data-cart-open]');
    if (!img || !target || reduced) return;
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    const c = img.cloneNode();
    Object.assign(c.style, { position: 'fixed', left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px', borderRadius: '24px', zIndex: 120, objectFit: 'cover', pointerEvents: 'none', transition: 'all .8s cubic-bezier(.6,-0.2,.3,1)' });
    document.body.appendChild(c);
    requestAnimationFrame(() => Object.assign(c.style, { left: b.left + 'px', top: b.top + 'px', width: '40px', height: '40px', opacity: '.3', borderRadius: '50%' }));
    setTimeout(() => { c.remove(); target.classList.add('is-bump'); setTimeout(() => target.classList.remove('is-bump'), 700); }, 800);
  }

  /* ---------- Cesta lateral ---------- */
  const drawer = $('[data-drawer]');
  const Cart = {
    async get() {
      if (MX.preview) return MX.preview.cart();
      const r = await fetch(MX.routes.cart, { headers: { Accept: 'application/json' } });
      return r.json();
    },
    async add(items) {
      if (MX.preview) return MX.preview.add(items);
      const r = await fetch(MX.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message);
      return j;
    },
    async change(line, quantity) {
      if (MX.preview) return MX.preview.change(line, quantity);
      const r = await fetch(MX.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      return r.json();
    },
    async render(cart) {
      cart = cart || (await this.get());
      $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
      if (!drawer) return;
      const box = $('[data-cart-items]', drawer);
      if (!cart.items.length) {
        box.innerHTML = '<div class="mx-drawer__empty"><p style="font-size:2.4rem">🦈</p><p>Tu cesta está vacía.<br>¡El tiburón tiene hambre!</p></div>';
      } else {
        box.innerHTML = cart.items.map((it, i) => {
          const img = it.image ? `${it.image}${it.image.includes('?') ? '&' : '?'}width=160` : '';
          const sub = it.variant_title ? `<small>Talla ${it.variant_title}</small>` : '';
          const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
          return `<div class="mx-line">${img ? `<img src="${img}" alt="">` : '<span></span>'}<div><h4>${it.product_title}</h4>${sub}<div class="mx-qty"><button type="button" data-q="${i + 1}" data-v="${it.quantity - 1}" aria-label="Quitar uno">−</button><span>${it.quantity}</span><button type="button" data-q="${i + 1}" data-v="${it.quantity + 1}" aria-label="Añadir uno">+</button></div></div><div class="mx-line__price">${money(it.final_line_price)}${was}</div></div>`;
        }).join('');
      }
      const disc = $('[data-cart-discount]', drawer);
      disc.hidden = !cart.total_discount;
      $('[data-cart-discount-val]', drawer).textContent = '−' + money(cart.total_discount || 0);
      $('[data-cart-total]', drawer).textContent = money(cart.total_price);
      $('[data-checkout]', drawer).toggleAttribute('hidden', !cart.items.length);
    },
    open() {
      if (!drawer) return;
      this.render();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => $('.mx-x', drawer)?.focus(), 300);
    },
    close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
  };
  window.MXCart = Cart;

  if (drawer) {
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); Cart.open(); }));
    $$('[data-cart-close]', drawer).forEach((b) => b.addEventListener('click', () => Cart.close()));
    addEventListener('keydown', (e) => e.key === 'Escape' && drawer.classList.contains('is-open') && Cart.close());
    drawer.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-q]');
      if (!b) return;
      const cart = await Cart.change(+b.dataset.q, +b.dataset.v);
      Cart.render(cart);
    });
  }
})();
